import { Component, Input, OnInit } from '@angular/core';
import { ProductUnit } from '@core/services/data.service';

@Component({
  selector: 'symbol-per-unit',
  templateUrl: './symbol-per-unit.component.html',
  styleUrls: ['./symbol-per-unit.component.scss']
})
export class SymbolPerUnitComponent implements OnInit {

  @Input()
  public symbol: string;

  @Input()
  public type: ProductUnit = ProductUnit.Unknown;

  public get name(): string {
    switch (this.type) {
      case ProductUnit.Meter: return 'm';
      case ProductUnit.Kilogram: return 'kg';
      default: return 'đv';
    }
  }

  constructor() { }

  ngOnInit(): void {
    switch (this.symbol) {
      case 'CNY': this.symbol = '¥'; break;
      case 'VND': this.symbol = 'đ'; break;      
    }
  }

}
